import './js/index';

// Images
import './images/loading-icons/Claridges-Loader.gif';
import './images/loading-icons/MBH-Loader.gif';
import './images/loading-icons/MBR-Loader.gif';
import './images/loading-icons/MHG-Loader.gif';
import './images/loading-icons/TheBerkeley-Loader.gif';
import './images/loading-icons/TheConnaught-Loader.gif';
import './images/loading-icons/TheEmory-Loader.gif';